module.exports = __webpack_public_path__ + "img/story-1.881606ed.webp";